var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.391,
    height: 16.276,
    viewBox: "0 0 18.391 16.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M29.289 100.33c-2.4-3.63-5.619-5.63-9.069-5.63s-6.67 2-9.069 5.63a.767.767 0 0 0 0 .845c2.4 3.63 5.619 5.63 9.069 5.63s6.67-2 9.069-5.63a.767.767 0 0 0 0-.845zm-9.069 4.944c-2.785 0-5.435-1.6-7.5-4.519 2.065-2.92 4.715-4.519 7.5-4.519s5.435 1.6 7.5 4.519c-2.064 2.92-4.711 4.519-7.5 4.519z",
    transform: "translate(-822 -420.048) translate(822 422.035) translate(-11.025 -94.7)"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#656565",
    stroke: "#fafafa",
    transform: "translate(-822 -420.048) translate(827.164 424.055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.036,
    cy: 4.036,
    r: 4.036,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.036,
    cy: 4.036,
    r: 3.536,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: "2.25px",
    d: "M11.981 0L0 11.981",
    transform: "translate(-822 -420.048) translate(825.084 421.639)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    d: "M13.978 0L0 13.978",
    transform: "translate(-822 -420.048) translate(825.084 421.639)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeStroke);
export default __webpack_public_path__ + "static/media/eye-stroke.svg";
export { ForwardRef as ReactComponent };